import { createContext } from 'react';
import { ScreenerResults } from 'domains/signup/screener/data/results';

type ScreenerResultsContext = {
  results: ScreenerResults;
  onProceedToSchedule: () => void;
};

export const ScreenerResultsCtx = createContext({} as ScreenerResultsContext);
